var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
define(["require", "exports", "preact/jsx-runtime", "ojs/ojmutablearraydataprovider", "preact/hooks", "ojs/ojknockout", "oj-c/message-toast"], function (require, exports, jsx_runtime_1, ojmutablearraydataprovider_1, hooks_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.AlertMessage = void 0;
    ojmutablearraydataprovider_1 = __importDefault(ojmutablearraydataprovider_1);
    const AlertMessage = ({ message, details }) => {
        const messageData = new ojmutablearraydataprovider_1.default([]);
        (0, hooks_1.useEffect)(() => {
            messageData.data = [
                { autoTimeout: 5000, detail: details, severity: "error", summary: message }
            ];
        }, [message, details]);
        return ((0, jsx_runtime_1.jsx)("oj-c-message-toast", { data: messageData, position: "top-right", onojClose: () => messageData.data = [] }));
    };
    exports.AlertMessage = AlertMessage;
});
